package ui.app.rss.instance


import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.utils.*
import tools.*
import ui.app.rss.*
import ui.app.rss.instance.detail.*
import ui.widget.*

@ComposableNavNode(AppRssListingArgs::class)
@Composable
fun AppRssListingInstanceUI() {
    with(AppRssListingInstanceScope.remember()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }

    }
}

@OptIn(ExperimentalFoundationApi::class)
@Composable
private fun AppRssListingInstanceScope.Content(nnvl: AppRssListingInstanceScope.Wrapper) {

    val stateHorizontal = rememberScrollState(0)
    val itemMeasurer = AppRssListingInstanceScope.headerSpecs.rememberMeasurer()

    Column(Modifier.fillMaxSize().padding(top = 8.dp).padding(start = 8.dp)) {
        HomeSearchUI(vm.searchFiled, label = Res.string.layer_bottom_rss_tab_instances_search)
        Space(8.dp)
        val scrollState = nav.rememberLazyListState("apps-rss")

        Box(
            Modifier.fillMaxSize()
        ) {
            Box(
                Modifier.fillMaxSize()
                    .tableMeasurer(itemMeasurer)
                    .horizontalScroll(stateHorizontal)
            ) {
                LazyColumn(
                    state = scrollState,
                    contentPadding = PaddingValues(end = 8.dp),
                    modifier = Modifier.fillMaxHeight()
                        .width(itemMeasurer.rowWidth)
                ) {
                    stickyHeader {
                        ListingHeader(AppRssListingInstanceScope.headerSpecs)
                    }
                    itemsIndexed(
                        SearchWrapper.use(
                            fields = arrayOf(
                                Io.ListingRssInstance.Item::id,
                                Io.ListingRssInstance.Item::idHex,
                                Io.ListingRssInstance.Item::name,
                                Io.ListingRssInstance.Item::nameChannel
                            ),
                            items = nnvl.state,
                            query = vm.searchFiled,
                            sort = compareByDescending { it.data.id }
                        )) { _, item ->
                        ListingDivider()
                        ListingItem(item, AppRssListingInstanceScope.headerSpecs) {
                            nav.findRoot().navTo_AppRssDetailInstanceUI(AppRssDetailInstanceArgs(item.data.id))
                        }
                    }
                    ListingFooter()
                }
            }

            FloatingActionButton(
                content = { Icon(Svg.Plus, null) },
                onClick = {
                    nav.findRoot().navTo_AppRssDetailInstanceUI(AppRssDetailInstanceArgs.creator)
                },
                modifier = Modifier.align(Alignment.BottomEnd)
                    .padding(8.dp)
            )

            HorizontalScrollbar(
                modifier = Modifier
                    .align(Alignment.BottomStart)
                    .padding(bottom = 8.dp)
                    .fillMaxWidth(),
                adapter = rememberScrollbarAdapter(stateHorizontal)
            )
        }
    }
}
